import { NgClass } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges
} from '@angular/core';
import { IconButtonComponent } from '../../button/button.component';
import { Icons } from '../../icon/constants/icons.constants';
import { IconComponent } from '../../icon/icon.component';
import { getIcon } from '../models/helpers';
import { NotificationTypeKeys } from '../models/notification-type.model';

@Component({
    selector: 'nw-dialog-box',
    // kept *.component.html for now as ESLint is not configured to handle *.html files
    templateUrl: './dialog-box.component.html',
    styleUrls: ['./dialog-box.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IconComponent, NgClass, IconButtonComponent]
})
export class DialogBox implements OnChanges {
    @Input() type: NotificationTypeKeys = 'information';
    @Output() closeBox: EventEmitter<void> = new EventEmitter<void>();

    icon: Icons.Type = Icons.Alerts.circle_info;

    public ngOnChanges({ type }: SimpleChanges): void {
        if (type?.currentValue) this.icon = getIcon(type.currentValue);
    }
}
